/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://emabk7tcr5bqtbnwcf3zmimtki.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-icdzer7lonbd7ewj2yjwk7ea44",
    "aws_cognito_identity_pool_id": "us-west-1:7bc65d27-6309-451b-94fb-633ac7bc7e81",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_nNQUPXjM6",
    "aws_user_pools_web_client_id": "s5tb3su4q1k6i55p237t4vlk2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "waitlistDB-dev",
            "region": "us-west-1"
        }
    ]
};


export default awsmobile;
